var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    iewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,21.2H5c-1.2,0-2.2-1-2.2-2.2V5c0-1.2,1-2.2,2.2-2.2h14c1.2,0,2.2,1,2.2,2.2v2.2c0.6,0.4,1,1.1,1,1.8v6 c0,0.7-0.4,1.4-1,1.8V19C21.2,20.2,20.2,21.2,19,21.2z M5,3.2C4,3.2,3.2,4,3.2,5v14c0,1,0.8,1.8,1.8,1.8h14c1,0,1.8-0.8,1.8-1.8v-2 H13c-1.3,0-2.2-0.8-2.2-2V9.3C10.8,8,11.7,7,13,7h7.8V5c0-1-0.8-1.8-1.8-1.8H5z M13,7.5c-1.1,0-1.8,0.7-1.8,1.8V15 c0,1.1,0.9,1.5,1.8,1.5h7.9c0.5-0.4,0.8-0.9,0.8-1.5V9c0-0.6-0.3-1.2-0.8-1.5H13z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16.6,
    cy: 12,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.1b97d6c82d5e059d17f6c2951e2e37cc.svg";
export { ForwardRef as ReactComponent };